export default "__VITE_ASSET__qkCvP$D2__"